<template>
	<img src="@/assets/svg/group-search.svg" />
</template>

<script>
export default {}
</script>

<style></style>
